import { Routes } from '@angular/router';
import { RoutePage } from './shared/enums/routes.enum';
import { appointmentSubmittedGuard } from './scheduler/guards/appointment-submitted.guard';
import { pendingUploadsGuard } from './scheduler/guards/pending-uploads.guard';
import { environmentCheckGuard } from './scheduler/guards/environment-check.guard';
import { ErrorPageComponent } from './pages/error-page/error-page.component';

export const routes: Routes = [
  { path: '', redirectTo: RoutePage.LANDING_PAGE, pathMatch: 'full' },
  {
    path: 'scheduler',
    children: [
      {
        path: RoutePage.LANDING_PAGE,
        loadComponent: () =>
          import('./pages/landing-page/landing-page.component').then(
            (m) => m.LandingPageComponent,
          ),
        canActivate: [appointmentSubmittedGuard],
        data: { containerWidth: '400' },
      },
      {
        path: RoutePage.SITE_MESSAGE,
        loadComponent: () =>
          import('./shared/components/site-message/site-message.component').then(
            (m) => m.SiteMessageComponent,
          ),
        canActivate: [appointmentSubmittedGuard],
      },
      {
        path: RoutePage.LOCATION_LAYOUT,
        loadComponent: () =>
          import('./pages/location-layout/location-layout.component').then(
            (m) => m.LocationLayoutComponent,
          ),
        canActivate: [appointmentSubmittedGuard],
      },
      {
        path: RoutePage.SERVICE_VIEW,
        loadComponent: () =>
          import('./pages/service-view/service-view.component').then(
            (m) => m.ServiceViewComponent,
          ),
        canActivate: [appointmentSubmittedGuard],
      },
      {
        path: RoutePage.CONFIRM_DATE_TIME,
        loadComponent: () =>
          import('./pages/confirm-date-time-appointment/confirm-date-time-appointment.component').then(
            (m) => m.ConfirmDateTimeAppointmentComponent,
          ),
        canActivate: [appointmentSubmittedGuard],
      },
      {
        path: RoutePage.PATIENT_INFO,
        loadComponent: () =>
          import('./pages/patient-info/patient-info.component').then(
            (m) => m.PatientInfoComponent,
          ),
        canActivate: [appointmentSubmittedGuard],
      },
      {
        path: RoutePage.CONFIRMATION_VIEW,
        loadComponent: () =>
          import('./pages/confirmation-view/confirmation-view.component').then(
            (m) => m.ConfirmationViewComponent,
          ),
        canActivate: [appointmentSubmittedGuard],
      },
      {
        path: RoutePage.UPCOMING,
        loadComponent: () =>
          import('./pages/upcoming/upcoming.component').then(
            (m) => m.UpcomingComponent,
          ),
        data: { containerWidth: '600' },
        canDeactivate: [pendingUploadsGuard],
      },
      {
        path: RoutePage.RECENT_UPLOADED_DOCUMENTS,
        loadComponent: () =>
          import('./pages/recent-documents/recent-documents.component').then(
            (m) => m.RecentDocumentsComponent,
          ),
        canActivate: [environmentCheckGuard],
      },
      {
        path: RoutePage.PATIENT_SEARCH,
        loadComponent: () =>
          import('./forms/patient-search/patient-search.component').then(
            (m) => m.PatientSearchComponent,
          ),
        data: { containerWidth: '420' },
      },
      {
        path: RoutePage.DOB_SEARCH,
        loadComponent: () =>
          import('./pages/dob-search-page/dob-search-page.component').then(
            (m) => m.DobSearchPageComponent,
          ),
        data: { containerWidth: '420' },
      },
      {
        path: RoutePage.DYNAMIC_FORM,
        loadComponent: () =>
          import('./scheduler/dynamic-form-container/dynamic-form-container.component').then(
            (m) => m.DynamicFormContainerComponent,
          ),
        canDeactivate: [pendingUploadsGuard],
      },
    ],
  },
  { path: 'error', component: ErrorPageComponent },
  { path: '**', redirectTo: RoutePage.LANDING_PAGE, pathMatch: 'full' },
];
